import { goToLink } from "@actions/common";
import {
	buildContainerViewAllLink,
	SLIDER_PREVIEW_LIMIT,
} from "@pages/casino/utils/bettoContainers";
import { getUser } from "@utils";
import React from "react";
import { getActiveLanguage } from "react-localize-redux";
import { useDispatch, useSelector } from "react-redux";
import BettoGameSlider from "../casinoSlider/gameSlider";
import BettoGameCard from "./gameCard.jsx";

const DotIcon = () => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<circle
			cx="9"
			cy="9"
			r="6"
			fill="var(--main-color)"
		/>
	</svg>
);

const selectLanguage = (state) => getActiveLanguage(state.localize)?.code || "en";

const defaultSorter = (data) => (a, b) =>
	data?.type === "userLastPlayed" ? -1 : a?.order - b?.order;

const BettoContainerSlider = ({ data, type, isGamePage, sortGames, containerPage }) => {
	const dispatch = useDispatch();
	const currentLanguage = useSelector(selectLanguage);

	if (!data?.isActive || !data?.gameList?.length) return null;

	const topic = data?.topic?.[currentLanguage] || data?.topic?.en;
	if (!topic) return null;

	const username = getUser()?.username;
	const title = topic.includes("{user}") ? topic.replace("{user}", username || "") : topic;
	const games = [...data.gameList]
		.sort(sortGames || defaultSorter(data))
		.slice(0, SLIDER_PREVIEW_LIMIT);
	const tab = type === "LiveCasino" ? "livecasino" : "casino";
	const resolvedContainerPage =
		containerPage ||
		(type === "LiveCasino" ? "LiveCasino" : type === "Casino" ? "Casino" : "Home");
	const viewAllLink = buildContainerViewAllLink(data, tab, resolvedContainerPage);

	return (
		<BettoGameSlider
			icon={
				data?.icon_url ? (
					<img
						src={data.icon_url}
						width="20"
						height="20"
						alt=""
					/>
				) : (
					<DotIcon />
				)
			}
			title={title}
			items={games}
			renderItem={(game, index) => (
				<BettoGameCard
					game={game}
					type={type}
					isGamePage={isGamePage}
					imageIndex={index}
				/>
			)}
			viewAllLink={viewAllLink}
			goToLink={(...args) => dispatch(goToLink(...args))}
			keyPrefix={`betto-${data.id}`}
		/>
	);
};

export default BettoContainerSlider;
